<template>
  <modal
    name="generalNotice"
    modal-style="compact"
    :display-header-title="false"
  >
    <general-notice />
  </modal>
</template>


<script>
  import GeneralNotice from './general-notice/index.vue';


  export default {
    name: 'GeneralNoticeModal',

    components: {
      GeneralNotice
    }
  };
</script>
